import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem, ProductUISidebarHeaderItem } from '../product-ui-list-item';
import { ProductUIQuickAddButton } from '../product-ui-quick-add-button/product-ui-quick-add-button';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { ProductUISidebar, ProfileMenu, SideBarSection } from '../product-ui-sidebar/product-ui-sidebar';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function TodayViewScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="TodayViewScene" data-sentry-source-file="today-view.tsx">
            <ProductUISceneLayer position="bottomRight" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="today-view.tsx">
                <ProductUIAppWindow inlineSize={808} blockSize="calc(100% + 7px)" showSidebar={true} sidebar={<ProductUISidebar profileMenu={<ProfileMenu dailyProgress={0.7} />} views={<SideBarSection>
                                    <ProductUIQuickAddButton abstracted />
                                    <ProductUIBasicListItem icon="search" skeletonWidth="20" abstracted />
                                    <ProductUIBasicListItem icon="inbox" skeletonWidth="20" abstracted />
                                    <ProductUICursorContainer size="lg">
                                        <ProductUIBasicListItem icon="dateToday" iconColor="theme" label={t('today')} active />
                                    </ProductUICursorContainer>
                                </SideBarSection>} workspaces={<>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="personal" abstracted={true} skeletonWidth="60" />
                                    </SideBarSection>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="team" abstracted={true} skeletonWidth="40" />
                                    </SideBarSection>
                                </>} />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="list">
                                <ProductUIView.Header title={t('today')} breadcrumbs={[]} />

                                <ProductUIView.Section variant="empty">
                                    {t('sequence.todayView.todoistZero')}
                                </ProductUIView.Section>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="today-view.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { TodayViewScene };